<div
    [id]="id"
    class="agpr-hoverMenu"
    [ngClass]="{'agpr-hoverMenu-social': social}"
    (mouseenter)="showMenu(menuEnum.MAIN)"
    (mouseleave)="hideMenu(menuEnum.MAIN, $event)"
>
    <button
        #button
        [id]="`${id}_button`"
        class="agpr-hoverMenu-button agpr-button"
        [ngClass]="{'agpr-hoverMenu-button--contextMenu': contextMenu}"
        aria-haspopup="menu"
        (click)="showMenu(menuEnum.MAIN)"
        (keydown)="onButtonKeydown($event)"
        [attr.aria-label]="'Common.charts.exportMenu' | localize"
        [attr.aria-controls]="id + '_menu'"
        [attr.aria-expanded]="showMainMenu"
        [agprTooltip]="'Reports.button.export'"
        tooltipPosition="top"
    >
        <span ngClass="{{iconStyleClass}}"  role="img"></span>
    </button>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <div class="agpr-hoverMenu-action" (focusout)="onFocusOut($event)" #menu>
        <ul
            [id]="`${id}_exportMenu`"
            class="agpr-hoverMenu-items"
            role="menu"
            agprListKeyboardNavigation
            [style.display]="showMainMenu ? 'block' : 'none'"
        >
            <li
                [id]="`${id}_exportMenu_image`"
                class="agpr-hoverMenu-item"
                role="menuitem"
                (mouseenter)="showMenu(menuEnum.IMAGE)"
                (mouseleave)="hideMenu(menuEnum.IMAGE, $event)"
                (focusin)="showMenu(menuEnum.IMAGE)"
                (focusout)="hideMenu(menuEnum.IMAGE)"
                (keydown)="onKeydown($event)"
            >
                <a
                    [id]="`${id}_exportMenu_image_link`"
                    class="agpr-hoverMenu-label"
                >
                    {{'Common.charts.exportMenu.image' | localize}}
                    <span class="fa-solid fa-angle-right" aria-hidden="true"></span>
                </a>
                <ul
                    [id]="`${id}_exportMenu_image_list`"
                    class="agpr-hoverMenu-subitems"
                    role="menu"
                    agprListKeyboardNavigation
                    [style.display]="showImagesMenu ? 'block' : 'none'"
                >
                    @for (format of imageFormats; track format; let i = $index) {
                        @if (formatsMap[format]) {
                            <li
                                [id]="`${id}_exportMenu_image_listItem_${i}`"
                                class="agpr-hoverMenu-subitem"
                                role="menuitem"
                                (keydown)="onItemKeyDown($event, format)"
                            >
                                <a
                                    [id]="`${id}_exportMenu_image_listItem_${i}_link`"
                                    class="agpr-hoverMenu-subitem-label agpr-hoverMenu-label--terminator"
                                    (click)="exportMenuItemClicked($event, format)"
                                >
                                    {{ format }}
                                </a>
                            </li>
                        }
                    }
                    <!--
                    @TODO: This is broken when built because it tries to load the pdfMake chunk with a base path of /
                    https://github.com/amcharts/export#2-manual has more details, but the files won't have the expected
                    names because we're adding a hash to the files
                    <li class="agpr-hoverMenu-subitem">
                        <a class="agpr-hoverMenu-label agpr-hoverMenu-label--terminator" (click)="exportMenuItemClicked($event)">PDF</a>
                    </li>
                    -->
                </ul>
            </li>
            @if (showDataSection) {
                <li
                    [id]="`${id}_exportMenu_data`"
                    class="agpr-hoverMenu-item"
                    role="menuitem"
                    (mouseenter)="showMenu(menuEnum.DATA)"
                    (mouseleave)="hideMenu(menuEnum.DATA, $event)"
                    (focusin)="showMenu(menuEnum.DATA)"
                    (focusout)="hideMenu(menuEnum.DATA)"
                    (keydown)="onKeydown($event)"
                >
                    <a
                        [id]="`${id}_exportMenu_data_link`"
                        class="agpr-hoverMenu-label"
                    >
                        {{'Common.charts.exportMenu.data' | localize}}
                        <span class="fa-solid fa-angle-right" aria-hidden="true"></span>
                    </a>
                    <ul
                        [id]="`${id}_exportMenu_data_list`"
                        class="agpr-hoverMenu-subitems"
                        role="menu"
                        agprListKeyboardNavigation
                        [style.display]="showDataMenu ? 'block' : 'none'"
                    >
                        @for (format of dataFormats; track format; let i = $index) {
                            @if (formatsMap[format]) {
                                <li
                                    [id]="`${id}_exportMenu_data_listItem_${i}`"
                                    class="agpr-hoverMenu-subitem"
                                    role="menuitem"
                                    (keydown)="onItemKeyDown($event, format)"
                                >
                                    <a
                                        [id]="`${id}_exportMenu_data_listItem_${i}_link`"
                                        class="agpr-hoverMenu-subitem-label agpr-hoverMenu-label--terminator"
                                        (click)="exportMenuItemClicked($event, format)"
                                    >
                                        {{ format }}
                                    </a>
                                </li>
                            }
                        }
                    </ul>
                </li>
            }
            @if (formatsMap['print']) {
                <li
                    [id]="`${id}_exportMenu_print`"
                    class="agpr-hoverMenu-item"
                    role="menuitem"
                    (mouseleave)="hideMenu(null, $event)"
                    (keydown)="onItemKeyDown($event, 'print')"
                >
                    <a
                        [id]="`${id}_exportMenu_print_link`"
                        class="agpr-hoverMenu-label agpr-hoverMenu-label--terminator"
                        (click)="exportMenuItemClicked($event, 'print')"
                    >
                        {{'Common.charts.exportMenu.print' | localize}}
                    </a>
                </li>
            }
        </ul>
    </div>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
</div>
